module.exports = __webpack_public_path__ + "3398733daef4809ed06c93a307c711cb.svg";